import { FC, PropsWithChildren } from "react";
import { Col, Row } from "taltech-styleguide";

/**
 * Functional Component: AuthPageBackground
 *
 * This component renders a background layout for authentication-related pages (e.g., login, logout). It includes a logo and
 * a section for child components, which can be passed in as the `children` prop. This component provides a consistent look and feel
 * for authentication pages by using a structured layout and background styling.
 *
 * Props:
 * @param {Object} props - The properties passed to the component.
 * @param {React.ReactNode} props.children - The content to be displayed in the main section of the authentication page.
 *
 * Returns:
 * @returns {JSX.Element} A JSX element that structures the background and layout for authentication pages.
 */
export const AuthPageBackground: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="App p-0">
      <div className="auth-page-background">
        <Row className="p-md-5 p-sm-3 surface-card shadow-2 border-round col-xl-8 col-lg-9 col-md-11 col-sm-10 col-10">
          <Col sm="12" md="6">
            <img
              src={"/Logo.png"}
              className="h-100 col-md-12 col-sm-7 col-8"
              alt=""
            />
          </Col>
          <Col md="6" className="d-flex flex-column justify-content-center">
            {children}
          </Col>
        </Row>
      </div>
    </div>
  );
};
